export const MONTHS_TO_DISPLAY = 4;
export const FIVE_MINUTES_STALE_TIME = 300000;
export const MINIMUM_PERCENTAGE_TO_DISPLAY = 10;
